document.addEventListener('submit', function(event) {
  const form = event.target.closest('[data-echo-product-form]');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  if (button) button.textContent = 'Adding…';
});
document.querySelectorAll('[data-echo-gallery]').forEach(function(gallery) {
  const slides = Array.from(gallery.querySelectorAll('.echo-slide'));
  const count = gallery.querySelector('[data-gallery-count]');
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  let activeSlides = slides.filter(function(slide) { return slide.hasAttribute('data-default-slide'); });
  if (!activeSlides.length) activeSlides = slides.slice(0, 1);
  let current = 0;
  function show(index) {
    current = (index + activeSlides.length) % activeSlides.length;
    slides.forEach(function(slide) { slide.classList.remove('is-active'); });
    activeSlides[current].classList.add('is-active');
    const hasGallery = activeSlides.length > 1;
    if (previous) previous.classList.toggle('is-hidden', !hasGallery);
    if (next) next.classList.toggle('is-hidden', !hasGallery);
    if (count) { count.classList.toggle('is-hidden', !hasGallery); count.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(activeSlides.length).padStart(2, '0'); }
  }
  if (previous) previous.addEventListener('click', function() { show(current - 1); });
  if (next) next.addEventListener('click', function() { show(current + 1); });
  gallery.closest('[data-echo-product]').querySelectorAll('[data-echo-variant-select]').forEach(function(select) {
    select.addEventListener('change', function() {
      const mediaId = select.options[select.selectedIndex].dataset.mediaId;
      const backUrl = select.options[select.selectedIndex].dataset.backUrl;
      const selectedSlide = slides.find(function(slide) { return slide.dataset.mediaId === mediaId; });
      if (selectedSlide) {
        const backSlide = gallery.querySelector('[data-color-back]');
        if (backUrl && backSlide) {
          const image = backSlide.querySelector('img');
          image.src = backUrl;
          image.alt = select.options[select.selectedIndex].text + ' back';
          activeSlides = [selectedSlide, backSlide];
        } else {
          activeSlides = [selectedSlide];
        }
        show(0);
      }
    });
  });
  show(0);
});
